<template>
	<apexchart width="100%" height="100%" type="bar" :options="chartOptions" :series="series" />
</template>

<script>
	export default {
		name: 'AppBarChart',
		props: {
			name: {
				type: String,
			},
			labels: {
				required: true,
				type: [Array],
			},
			series: {
				required: true,
				type: [Array],
			},
			isHorizontal: {
				type: Boolean,
				default: false,
			},
			isCurrency: {
				type: Boolean,
				default: true,
			},
			currency: {
				default: () => ({}),
			},
		},
		computed: {
			chartOptions() {
				return {
					plotOptions: {
						bar: {
							borderRadius: 2,
							horizontal: this.isHorizontal,
						},
					},
					chart: {
						id: this.name,
						type: 'bar',
					},
					dataLabels: {
						enabled: false,
					},
					xaxis: {
						categories: this.labels,
					},
					yaxis: {
						labels: {
							formatter: (value) => {
								if (typeof value === 'number' && this.isCurrency) {
									return this.$filters.formatCurrency(value, this.currency);
								}
								return value;
							},
						},
					},
					legend: {
						position: 'top',
						labels: {
							useSeriesColors: true,
						},
					},
				};
			},
		},
	};
</script>
